<template>
<div style="height: 100%">
  <el-table :data="locationList" ref="Location" border style="width: 100%;" highlight-current-row>
    <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
    <el-table-column prop="time" label="时间范围" min-width="135" align="center">
      <template slot-scope="scope">
        <span>{{scope.row.startEndTime[0]}}~{{scope.row.startEndTime[1]}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="time" label="定位间隔" min-width="135" align="center">
      <template slot-scope="scope">
        <span>{{scope.row.time}}分钟</span>
      </template>
    </el-table-column>
    <el-table-column label="定位模式" min-width="135" align="center">
      <template slot-scope="scope">
        <span>{{showModel(scope.row.model)}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="操作" width="130">
      <template slot-scope="scope">
        <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editLocation(scope.row, scope.$index)"></i>
        <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delLocation(scope.row, scope.$index)"></i>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="550px" :show-close="true" :close-on-click-modal="false"
             center append-to-body class="all-open">
    <div class="title-top-alarm">
      <div> <span>{{addEditTitle}}</span> </div>
      <div class="line-title"></div>
      <el-form style="margin: 20px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="时间范围" prop="startEndTime">
          <el-time-picker v-fixZoom :clearable="false" is-range v-model="addEditForm.startEndTime"
                          range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                          value-format="HH:mm" format="HH:mm" placeholder="选择时间范围"
                          style="width: 100%" >
          </el-time-picker>
        </el-form-item>
        <el-form-item label="定位间隔" prop="time">
          <el-input placeholder="请输入" v-model="addEditForm.time">
            <template slot="append">分钟</template>
          </el-input>
        </el-form-item>
        <el-form-item label="定位模式" prop="model">
          <el-select v-fixZoom style="width: 100%" v-model="addEditForm.model" placeholder="请选择">
            <el-option v-for="item in modelArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="height: 60px;margin: 30px 30px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="addEditShow = false"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitLocation('addEditForm')"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {sendcommand} from '../../../api/device'

export default {
  name: 'requireLocation',
  props: {
    listObj: {
      type: Object,
      default: null
    },
    locationCommand: {
      type: String
    }
  },
  data () {
    return {
      deviceRow: {
        devicetype: 0
      },
      modelArr: [{name: '基站', id: 1}, {name: 'wifi', id: 2}, {name: '自动高精度', id: 4}, {name: '自动最快', id: 5}],
      locationList: [],
      allLocationList: [],
      indexNum: 0,
      addEditShow: false,
      addEditTitle: '',
      addEditForm: {
        startEndTime: [],
        time: '',
        model: 1
      },
      addEditRules: {
        startEndTime: [{ required: true, message: '请选择', trigger: 'change' }],
        time: [{ required: true, message: '请输入', trigger: 'blur' }],
        model: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    }
  },
  created () {
    this.deviceRow = this.clone(this.listObj.deviceRow)
    this.getDeviceLocationData(this.locationCommand)
  },
  methods: {
    getDeviceLocationData (command) {
      let arr = []
      if (command !== '') {
        let list = command.split(';')
        list.forEach(item => {
          let list1 = item.split('|')
          let list2 = list1[1].split('#')
          let obj = {startEndTime: [list2[0], list2[1]], time: parseFloat(list2[2]) / 60, model: parseFloat(list2[3])}
          arr.push(obj)
        })
      }
      console.log(arr)
      this.locationList = arr
      this.allLocationList = arr
    },
    showModel (model) {
      let show = model
      this.modelArr.forEach(item => {
        if (item.id === model) {
          show = item.name
        }
      })
      return show
    },
    addLocation () {
      this.addEditTitle = '添加定位设置'
      this.addEditForm = {startEndTime: ['08:00', '18:00'], time: '', model: 1}
      this.addEditShow = true
    },
    editLocation (row, index) {
      this.indexNum = index
      this.addEditForm = row
      this.addEditTitle = '编辑定位设置'
      this.addEditShow = true
    },
    delLocation (row, index) {
      this.indexNum = index
      this.addEditForm = row
      this.addEditTitle = '删除定位设置'
      this.sendCommand('requirelocationperiod310')
    },
    submitLocation (formName) {
      let vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.sendCommand('requirelocationperiod310')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    sendCommand (met) {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: met,
        command1: ''
      }
      let arr = []
      if (met === 'requirelocationperiod310') {
        arr = this.clone(this.allLocationList)
        if (this.addEditTitle === '添加定位设置') {
          arr.push(this.addEditForm)
        } else if (this.addEditTitle === '删除定位设置') {
          arr = arr.filter((item, i) => i !== this.indexNum)
        } else if (this.addEditTitle === '编辑定位设置') {
          arr[this.indexNum] = this.addEditForm
        }
        console.log(arr)
        let command1 = ''
        arr.forEach(item => {
          let val = '2|' + item.startEndTime[0] + '#' + item.startEndTime[1] + '#' + item.time * 60 + '#' + item.model
          if (command1 === '') {
            command1 = val
          } else {
            command1 = command1 + ';' + val
          }
        })
        data.command1 = command1
      }
      console.log(data)
      // this.$emit('getCommandData')
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置设备', type: 'success', duration: 2000 })
        this.addEditShow = false
        this.$emit('getCommandData')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/requireLocation.vue